import { createReducer, on } from "@ngrx/store";

import * as RegionActions from "./region.actions";
import { RegionState } from "./region.model";

export const regionFeatureKey = "region";

export const initialState: RegionState = {
  regions: [],
  loading: false,
  error: null,
  selectedRegions: [],
};

export const regionReducer = createReducer(
  initialState,
  on(RegionActions.loadRegions, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RegionActions.loadRegionsSuccess, (state, { regions }) => ({
    ...state,
    regions,
    selectedRegions: regions.map(region => region.name),
    loading: false,
  })),
  on(RegionActions.loadRegionsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(RegionActions.toggleSelectedRegion, (state, { region }) => {
    const isSelected = state.selectedRegions.includes(region);
    const newSelectedIds = isSelected
      ? state.selectedRegions.filter(id => id !== region)
      : [...state.selectedRegions, region];

    return {
      ...state,
      selectedRegions: newSelectedIds,
    };
  }),
  on(RegionActions.clearSelectedRegions, state => ({
    ...state,
    selectedRegions: [],
  })),
  on(RegionActions.selectAllRegions, state => {
    const allRegionNames = state.regions.map(region => region.name);

    return {
      ...state,
      selectedRegions: allRegionNames,
    };
  })
);
